if (!customElements.get('media-gallery')) {
  class MediaGalleryFlickity {
    constructor(element) {
      this.element = element;

      this.viewer = element.querySelector(
        '[id^="GalleryViewer"]'
      );

      this.thumbnails = element.querySelector(
        '[id^="GalleryThumbnails"]'
      );

      this.heightObserver = null;
      this.mainSlider = null;

      if (!this.viewer) return;

      this.init();
    }

    init() {
      this.initSlider();
      this.initHeightObserver();
      this.bindThumbnailEvents();
      this.bindArrowEvents();
      this.bindSliderEvents();
      this.overrideDawnMethods();

      this.onSlideChange(
        this.mainSlider.selectedIndex || 0
      );
    }
refresh() {
  if (!this.mainSlider) return;

  this.mainSlider.reloadCells();
  this.mainSlider.resize();

  this.syncThumbnailHeight();
}
    destroy() {
      if (this.heightObserver) {
        this.heightObserver.disconnect();
        this.heightObserver = null;
      }

      if (this.mainSlider) {
        this.mainSlider.destroy();
        this.mainSlider = null;
      }
    }

    initSlider() {
      this.mainSlider = new Flickity(
        this.viewer,
        {
          cellSelector:
            '.product__media-item',

          contain: false,
          adaptiveHeight: true,
          pageDots: false,
          prevNextButtons: false,
          draggable: true,
          wrapAround: false,
          imagesLoaded: true
        }
      );
    }

    initHeightObserver() {
      if (!this.thumbnails) return;

      const viewport =
        this.viewer.querySelector(
          '.flickity-viewport'
        );

      if (!viewport) return;

      this.syncThumbnailHeight();

      this.heightObserver =
        new ResizeObserver(() => {
          this.syncThumbnailHeight();
        });

      this.heightObserver.observe(
        viewport
      );
    }

    syncThumbnailHeight() {
      if (!this.thumbnails) return;

      const viewport =
        this.viewer.querySelector(
          '.flickity-viewport'
        );

      if (!viewport) return;

      const height =
        viewport.getBoundingClientRect()
          .height;

      this.thumbnails.style.height =
        `${Math.round(height)}px`;
    }

    bindSliderEvents() {
      this.mainSlider.on(
        'change',
        (index) => {
          this.onSlideChange(index);
        }
      );

      this.mainSlider.on(
        'settle',
        () => {
          this.syncThumbnailHeight();
        }
      );
      this.mainSlider.on(
        'ready',
        () => {
          this.mainSlider.resize();
        }
      );
    }

    bindThumbnailEvents() {
      if (!this.thumbnails) return;

      const thumbs =
        this.thumbnails.querySelectorAll(
          '.thumbnail-list__item'
        );

      thumbs.forEach(
        (thumb, index) => {
          thumb.addEventListener(
            'click',
            (event) => {
              event.preventDefault();

              this.mainSlider.select(
                index
              );
            }
          );
        }
      );
    }

    bindArrowEvents() {
      const prevBtn =
        this.element.querySelector(
          '.thumb-prev'
        );

      const nextBtn =
        this.element.querySelector(
          '.thumb-next'
        );

      if (!prevBtn || !nextBtn)
        return;

      prevBtn.addEventListener(
        'click',
        () => {
          this.mainSlider.previous();
        }
      );

      nextBtn.addEventListener(
        'click',
        () => {
          this.mainSlider.next();
        }
      );
    }

    updateArrowState(index) {
      const prevBtn =
        this.element.querySelector(
          '.thumb-prev'
        );

      const nextBtn =
        this.element.querySelector(
          '.thumb-next'
        );

      if (!prevBtn || !nextBtn)
        return;

      const total =
        this.mainSlider.slides.length;

      prevBtn.disabled =
        index === 0;

      nextBtn.disabled =
        index === total - 1;
    }

    onSlideChange(index) {
      const slides =
        this.viewer.querySelectorAll(
          '.product__media-item'
        );

      slides.forEach((slide) => {
        slide.classList.remove(
          'is-active'
        );
      });

      const activeSlide =
        slides[index];

      if (!activeSlide) return;

      activeSlide.classList.add(
        'is-active'
      );

      this.updateActiveThumbnail(
        index
      );

      this.updateArrowState(
        index
      );

      this.handleMediaPlayback(
        activeSlide
      );
    }

    updateActiveThumbnail(index) {
      if (!this.thumbnails) return;

      const thumbs =
        this.thumbnails.querySelectorAll(
          '.thumbnail-list__item'
        );

      thumbs.forEach((thumb) => {
        thumb.classList.remove(
          'is-active'
        );

        const button =
          thumb.querySelector(
            'button'
          );

        if (button) {
          button.removeAttribute(
            'aria-current'
          );
        }
      });

      const activeThumb =
        thumbs[index];

      if (!activeThumb) return;

      activeThumb.classList.add(
        'is-active'
      );

      const button =
        activeThumb.querySelector(
          'button'
        );

      if (button) {
        button.setAttribute(
          'aria-current',
          'true'
        );
      }

      if (index <= 1) {
        this.thumbnails.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

        return;
      }

      const styles =
        window.getComputedStyle(
          activeThumb
        );

      const marginBottom =
        parseFloat(
          styles.marginBottom
        ) || 0;

      const thumbHeight =
        activeThumb.offsetHeight +
        marginBottom;

      const scrollTop =
        activeThumb.offsetTop -
        thumbHeight;

      this.thumbnails.scrollTo({
        top: Math.max(
          0,
          scrollTop
        ),
        behavior: 'smooth'
      });
    }

    handleMediaPlayback(activeSlide) {
      if (
        typeof window.pauseAllMedia ===
        'function'
      ) {
        window.pauseAllMedia();
      }

      const deferred =
        activeSlide.querySelector(
          '.deferred-media'
        );

      if (
        deferred &&
        typeof deferred.loadContent ===
          'function'
      ) {
        deferred.loadContent(false);
      }
    }
selectMedia(mediaId) {
  this.mainSlider.reloadCells();
  this.mainSlider.resize();

  const flickityIndex =
    this.mainSlider.cells.findIndex(
      (cell) =>
        cell.element.dataset.mediaId ===
        mediaId
    );

  console.log(
    'flickityIndex',
    flickityIndex
  );

  if (flickityIndex < 0) return;

  this.mainSlider.select(
    flickityIndex
  );
}
    // selectMedia(mediaId) {
    //     console.log('selectMedia', mediaId);
    //   const slide =
    //     this.viewer.querySelector(
    //       `[data-media-id="${mediaId}"]`
    //     );

    //   if (!slide) return;

    //   const slides = [
    //     ...this.viewer.querySelectorAll(
    //       '[data-media-id]'
    //     )
    //   ];

    //   const index =
    //     slides.indexOf(slide);

    //   if (index < 0) return;

    //   this.mainSlider.select(index);
    // }

    overrideDawnMethods() {
      this.element.setActiveMedia =
        (mediaId) => {
          this.selectMedia(mediaId);
        };

      this.element.setActiveThumbnail =
        () => {};

      this.element.onSlideChanged =
        () => {};
    }
  }

  customElements.define(
    'media-gallery',
    class extends HTMLElement {
      connectedCallback() {
        this.instance =
          new MediaGalleryFlickity(
            this
          );
      }

      disconnectedCallback() {
        this.instance?.destroy();
      }
    }
  );
}